export default "__VITE_ASSET__CxxhmLEl__"